import React from 'react';
import { motion } from 'framer-motion';
import { awardGalleryImages } from '../data/siteContent';

const Award = () => {
  return (
    <section className="award-gallery-section">
      <div className="container">
        <div className="centers-heading">
          <span className="section-kicker">Recognition</span>
          <h2 className="section-title">Award Gallery</h2>
          <p className="centers-disclaimer">
            Awards, recognition moments, and event highlights shown without cropping so each image keeps
            its natural proportions.
          </p>
        </div>

        <motion.div
          className="award-gallery-grid"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
        >
          {awardGalleryImages.map((image, index) => (
            <motion.figure
              key={`${image.alt}-${index}`}
              className="award-gallery-item"
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: index * 0.04 }}
            >
              <img src={image.src} alt={image.alt} />
            </motion.figure>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default Award;
